<template>
<div>
  <!-- Promo Block -->
      <div class="g-bg-img-hero" style="background-image: url('../../../../static/assets/include/svg/svg-bg1.svg');">
        <div class="container g-py-50 g-pt-100--lg g-pb-20--lg">
          <div class="row align-items-lg-center">
            <div class="col-lg-6 g-mb-70 g-mb-150--sm g-mb-50--lg">
              <div class="g-pr-15--lg">
                <!-- Promo Block Info -->
                <div class="mb-5">
                  <h1 class="g-font-size-45 mb-3">Share a Success Story!</h1>
                  <p class="g-font-size-20">Have an inspiring story or best practice to improve delivery of vision services to those in need?  Please share your experiences and upload images to bring to life your contributions in your community.</p>
                </div>
                <div class="text-center">
                  <a class="btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-70 g-py-13 mr-2 g-font-size-18" v-on:click="ShowModal()">Share a Story</a>
                </div>
              </div>
            </div>

            <div class="col-lg-6 g-mb-50">
              <div class="g-max-width-550 g-pos-rel g-pl-15--lg mx-auto">
                <!-- Promo Block Images -->
                <div class="g-max-width-300--sm g-pos-rel g-z-index-1 g-mb-20 g-mb-0--sm img-story-1">
                  <img class="u-shadow-v36 img-fluid g-brd-around g-brd-4 g-brd-white rounded g-mt-80" :src="success_story_1" alt="Photo_Family2">
                </div>

                <div class="u-shadow-v36 g-max-width-300--sm g-pos-abs--sm g-top-minus-70 g-left-130 g-z-index-0 g-mb-20 g-mb-0--sm">
                  <img class="img-fluid g-brd-around g-brd-4 g-brd-white rounded" :src="success_story_2" alt="Photo_DoctorImage5">
                </div>

                <div class="u-shadow-v36 g-max-width-300--sm g-pos-abs--sm g-top-65 g-right-0 g-mt-40">
                  <img class="img-fluid g-brd-around g-brd-4 g-brd-white rounded" :src="success_story_3" alt="Photo_FamilyImage5">
                </div>
                <!-- End Promo Block Images -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Promo Block -->
      <share-story-form v-if="isModalShown" @closeWufoo="CloseModal()"></share-story-form>
</div>
</template>
<script>
import ShareStoryForm from "@/components/portal/homeData/ShareStoryForm";
export default {
  components: {ShareStoryForm},
  data() {
    return{
      isModalShown: false
    }
  },
  methods: {
    ShowModal() {
      this.isModalShown = !this.isModalShown; 
      document.body.classList.add("body-overflow");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeStory.vue?f10f1690